var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBookmark = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "0 0 24 24",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20.05 19.541a2.175 2.175 0 0 1-2.176 2.176H6.144a2.175 2.175 0 0 1-2.177-2.176V4.46c0-1.202.974-2.176 2.176-2.176h11.731c1.202 0 2.176.974 2.176 2.176Zm-1-1.522-.036.024a2.17 2.17 0 0 1-1.14.322l.158-.005a2.21 2.21 0 0 1-.158.005H6.144a1.175 1.175 0 1 0 0 2.352h11.73c.65 0 1.176-.526 1.176-1.176V18.02Zm-13.742-.487.03-.013a2.16 2.16 0 0 1 .65-.148l-.156.016c.102-.014.206-.022.311-.022h11.731c.65 0 1.176-.526 1.176-1.175V4.459c0-.65-.526-1.176-1.176-1.176h-4.528v7.138l-3.013-2.01-3.014 2.01V3.283H6.142c-.606 0-1.105.458-1.169 1.048l-.007.128V17.71l.036-.024a2.172 2.172 0 0 1 .26-.136l.045-.02Zm7.038-14.249H8.318v5.269l2.015-1.342 2.014 1.342V3.283Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBookmark);
export default ForwardRef;